import React, { Component } from 'react';
import { Field, reduxForm, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import {
    renderTextInputField,
    renderRadioInputField
} from '../Layout/FormInputs'
import { toastr } from 'react-redux-toastr';
import { langs } from '../../config/localization';
import { registerUser } from "../../actions/Auth/AuthActions";
import {required, urlFormat, maxLength100, maxLength50} from '../../validation';
import { getVideoDetailLocalStorage } from "../../actions/Common";
import { saveVideoClickData } from "../../actions/DashboardAction";
import {Loader} from "../Common/Loader";
import {focusOnError} from "../../utils";

export function renderStoryItems(field) {
    const {fields, meta: {error}} = field;
    return (
        <div className="row">
            {fields.map((nameWebsites, index) => (
            <div className="m-t20" key={index}>
                <div className="medium-5 columns">
                    <div className="form-group">
                        <label>Title of Story</label>
                        <Field
                            name={`${nameWebsites}.Title`}
                            component={renderTextInputField}
                            validate={[maxLength50]}
                            maxLength="50"
                        />
                    </div>
                </div>
                <div className="medium-5 columns">
                    <div className="form-group">
                        <label>Website (s)?</label>
                        <Field
                            name={`${nameWebsites}.Website`}
                            component={renderTextInputField}
                            validate={[urlFormat, maxLength100]}
                            maxLength="100"
                        />

                    </div>
                </div>
                {(fields.length > 1) && <div className="medium-2 columns">
                        <label></label>
                        <button type="button" className="btn-delete" onClick={(e) => {field.deleteItem(fields,index)}}>
                            Delete
                        </button>
                    </div>}
                </div>

            ))}

            <div className="medium-12 columns">
                <button type="button" onClick={() => {fields.push({});}} className="btn-add"><span>+</span> ADD MORE</button>
            </div>
            {error && <li className="error">{error}</li>}
        </div>
    )
}

class ProfileQuestion extends Component {

    constructor(props) {
        super(props);
        this.onChangeStoryCheckBox = this.onChangeStoryCheckBox.bind(this);
        this.state = {
            showTitleWebsite:false,
            nameWebsites:[{Title:'', Website:''}],
            contentLikeList:{
                action_network_events: 'Action Network Events',
                action_network_initiatives: 'Action Network Initiatives',
                action_network_news: 'Action Network News',
                media_entertainment_for_a_cause: 'Media & Entertainment for a Cause',
                data_research: 'Data & Research',
                innovation_unicorns: 'Innovation & Unicorns',
                learning_content_tool: 'Learning content & tools',
                sustainable_tourism: 'Sustainable Tourism'
            },
            socialNetworkList: {
                action_networks: 'Action Networks',
                angel_donors: 'Angel Donors',
                financing: 'Financing (blockchain, tokens etc.)',
                gaming_for_good: 'Gaming for Good',
                nature_and_wilderness: 'Nature and Wilderness',
                outdoors_and_sports: 'Outdoors and Sports',
            }

        };
    }

    componentWillMount() {
        const signupData = this.props.signupData;

        if(typeof signupData == 'undefined' || !signupData.hasOwnProperty('name')){
            window.location.assign('/signup');
        }
    }


    /**
     * when User select the own story
     * @param boolean
     */
    onChangeStoryCheckBox(event, value){
        if(value == "working on championing a stories"){
            this.setState({showTitleWebsite: true});
        }else{
            this.setState({showTitleWebsite: false});
        }
    }

    /**
     * @name deleteItem
     * @desc Delete Purchanse items
     */
    deleteItem(fields, index){
        const toastrConfirmOptions = {
            onOk: () => {fields.remove(index);},
            onCancel: () => {}
        };
        return toastr.confirm('Are you sure you want to delete this item?', toastrConfirmOptions);
    }

    contentLikeHtml() {
        return _.map(this.state.contentLikeList, (value, key) => {
            return (
                <li key={key}>
                    <Field
                        name={`contentLike.${key}`}
                        type="checkbox"
                        component={renderRadioInputField}
                        label={value}
                    />
                </li>
            );
        });
    }
    contentNetworkHtml() {
        return _.map(this.state.socialNetworkList, (value, key) => {
            return (
                <li key={key}>
                    <Field
                        name={`socialNetworks.${key}`}
                        type="checkbox"
                        component={renderRadioInputField}
                        label={value}
                    />
                </li>
            );
        });
    }

    /**
     * User signup
     * @param values
     */
    onSubmit = (values) => {
        this.setState({ showLoader: true });
        /* temp data */
        let pqDetails = {
            yourStories:{
                selectedOption:"",
                nameWebsites:[],
            },
            contentLike:[],
            socialNetworks:{
                selectedOptions:[],
                other:""
            }
        }

        pqDetails.yourStories.selectedOption = values.selectedOption;
        pqDetails.socialNetworks.other = (typeof values.otherComment !== 'undefined' && values.otherComment !== null && values.otherComment !=='')?String.prototype.trim.call(values.otherComment):'';

        let trimmedNameWebsite = [];
        /** Reset the array accroding to */
        if(values.selectedOption != 'working on championing a stories'){
            pqDetails.yourStories.nameWebsites = [];
        }else{
            //pqDetails.yourStories.nameWebsites = values.nameWebsites;
            if(values.nameWebsites.length>0){
                trimmedNameWebsite =   values.nameWebsites.map(function(nameWebsite){

                    nameWebsite.Title = (typeof nameWebsite.Title !=='undefined'
                    && nameWebsite.Title !==''
                    && nameWebsite.Title !==null ) ? String.prototype.trim.call(nameWebsite.Title):'';
                    nameWebsite.Website = (typeof nameWebsite.Website !=='undefined'
                    && nameWebsite.Website !==''
                    && nameWebsite.Website !==null) ? String.prototype.trim.call(nameWebsite.Website):'';
                        return nameWebsite;
                });

                trimmedNameWebsite.map(function(nameWebsite){
                    if(nameWebsite.Title !=='' || nameWebsite.Website !==''){
                        pqDetails.yourStories.nameWebsites.push(nameWebsite);
                    }
                });
            }
        }
        pqDetails.yourStories.nameWebsites = pqDetails.yourStories.nameWebsites.filter(item => typeof item !== 'undefined');

        if(values.contentLike){
            pqDetails.contentLike = Object.keys(values.contentLike).map(function(contentLiked) { return contentLiked})
        }
        if(values.socialNetworks){
            pqDetails.socialNetworks.selectedOptions = Object.keys(values.socialNetworks).map(function(socialNetwork) { return socialNetwork})
        }
        let finalData = {};
        if(typeof this.props.signupData !== 'undefined'){
            finalData = this.props.signupData;
            finalData.profile = pqDetails;
        }else{
            toastr.error(langs.error, langs.messages.invalid_access);

            // Delay the page redirection for 1 second to show toastr message
            setTimeout(function () {
                window.location.assign('/signup');
            }.bind(this), 3000);
        }

        //Call the register user action
        this.props.registerUser(finalData, (response) => {
            this.setState({ showLoader: false });
            if(response.status === 201) {

                toastr.success(langs.success, langs.messages.registration_success);
                //Delay the page redirection for 3 second to show toastr message
                let video_detail = getVideoDetailLocalStorage();
                /* As here auth token is not generated so need to remove Auth token from the API
                That's why comment code here for now. */
                // this.props.saveVideoClickData(video_detail, (response)=>{
                //     console.log("video detail Saved", response);
                // });
                setTimeout(function () {
                    window.location.assign('/signup-success');
                }.bind(this), 3000);
            } else if(response.status === 409) {//If email already exist

                toastr.error(langs.error, response.data.error.message);
                //Delay the page redirection for 3 second to show toastr message
                setTimeout(function () {
                    window.location.assign('/signup');
                }.bind(this), 3000);
            }else{

                toastr.error(langs.error, langs.messages.default_error);
                //Delay the page redirection for 3 second to show toastr message
                setTimeout(function () {
                    window.location.assign('/signup');
                }.bind(this), 3000);
            }
        });
    }

    /**
     * Render the login form
     * @returns {*}
     */
    render() {
        const { handleSubmit } = this.props;

        if(!this.state.showLoader) {
        return (
            <section className="profile-questions">
                <div className="row">
                    <div className="medium-12 columns">
                        <div className="breadcumb">
                            <a href="/signup" className="breadcumb-underline">Sign up </a> >  <span className="active breadcumb-underline">Profile Questions</span> {/*<a href="" className="active">Profile Questions</a>*/}
                        </div>
                        <h1 className="text-center m-t20">
                            Profile Questions
                        </h1>
                        <p className="text-center m-t20 m-b30">
                            Complete signup by answering the questions below, which will enable our CIQ* system to customize your earthDECK. *CIQ – Collaborative Intelligence
                        </p>
                        <form noValidate className="PQform" onSubmit={handleSubmit(this.onSubmit)}>
                            <div id="yourStory" className="profile-questions-heading primary-gradient-bg">
                                Your story
                            </div>
                            <div className="questions">
                                <div className="form-group">
                                    {/* <label>Do you have a story we should know about?</label> */}
                                    <Field
                                        label="Do you have a story we should know about?"
                                        name="selectedOption"
                                        type="radio"
                                        value="working on championing a stories"
                                        component={renderRadioInputField}
                                        onChange={this.onChangeStoryCheckBox}
                                    />
                                </div>
                                {(this.state.showTitleWebsite == true) && <FieldArray name={'nameWebsites'} deleteItem={this.deleteItem} component={renderStoryItems}/>}
                            </div>
                            <div className="profile-questions-heading primary-gradient-bg m-t30">
                                Content you like <span className="note">(Click as many as apply)</span>
                            </div>
                            <div className="questions">
                                <ul className="small-block-grid-1 medium-block-grid-2">
                                    {this.contentLikeHtml()}
                                </ul>
                            </div>
                            <div className="profile-questions-heading primary-gradient-bg m-t30">
                                You & your social network(s) <span className="note">(Click as many as apply)</span>
                            </div>
                            <div className="questions">
                                <ul className="small-block-grid-1 medium-block-grid-2">
                                    {this.contentNetworkHtml()}
                                </ul>
                                <div className="row m-t20">
                                    <div className="medium-12 columns">
                                        <div className="form-group">

                                            <label>Other comments (not covered above)</label>
                                            <Field
                                                name="otherComment"
                                                validate={[maxLength50]}
                                                component={renderTextInputField}
                                                maxLength="50"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center m-t40 m-b40">
                                <button type="submit" className="btn-primary primary-gradient-bg">
                                    <span>SUBMIT</span>
                                </button>
                                {/* <a href="/welcome" className="btn-primary primary-gradient-bg">SUBMIT</a> */}
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        );
    } else {
        return <Loader loaderContent='form-submission' />
    }
    }
}

/**
 * Form validations
 * @param values
 * @returns {{}}
 */
function validate(values) {
    let errors = {};
    return errors;
}

/**
 * Assign reducer's data to props
 * @param auth
 * @returns {{signupData: *}}
 */
const mapStateToProps = ({ auth }) => {
    let signupData = auth.signupData;
    //Keep values in initial values object to be passed on form submit

    return {
        signupData: signupData, initialValues: {nameWebsites : [{Title:'',Website:''}]}
    };
};

/**
 * Connect action to component
 */
export default connect(mapStateToProps, {registerUser, saveVideoClickData})(reduxForm({
    form: 'ProfileQuestionForm',
    validate: validate,
    onSubmitFail: (errors) => {
        focusOnError(errors)
    }
})(ProfileQuestion));



// WEBPACK FOOTER //
// ./components/Auth/ProfileQuestion.js